var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", { staticClass: "py-4" }, [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _vm.isLoading
      ? _c("div", [_c("loading-spinner-small")], 1)
      : _c("div", [
          _vm.isErrored
            ? _c("div", { staticClass: "mt-4 alert alert-error" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.CONSTANTS.SERVER_ERROR_MESSAGE) +
                    "\n        "
                )
              ])
            : _c("div", [
                _c(
                  "div",
                  [
                    _c("event-feed-filters", {
                      attrs: {
                        topics: _vm.topics,
                        "reset-filters": _vm.resetFilters
                      },
                      on: {
                        updateSearchTerm: function($event) {
                          return _vm.handleSearch($event)
                        },
                        updateDateFilterValue: function($event) {
                          return _vm.handleDateFilterChange($event)
                        },
                        interestsSaved: _vm.resetEventsFeed
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", [
                  _vm.filteredEvents && _vm.filteredEvents.length > 0
                    ? _c(
                        "div",
                        { staticClass: "mt-4" },
                        [
                          _vm._l(_vm.filteredEvents, function(event) {
                            return _c("div", { key: event.uniqueId }, [
                              _c(
                                "div",
                                { staticClass: "pb-3" },
                                [
                                  _c("event-feed-card", {
                                    attrs: {
                                      "event-data": event,
                                      "user-email": _vm.user.email,
                                      isAddedToCalendar: _vm.setIsAddedToCalendar(
                                        event.uniqueId
                                      )
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "load-more-wrapper d-flex justify-content-center pb-4"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center pb-4"
                                },
                                [
                                  _vm.isMoreLoading
                                    ? _c(
                                        "div",
                                        { staticClass: "more-loading-spinner" },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: _vm.spinnerUrl,
                                              alt: "Loading Spinner"
                                            }
                                          })
                                        ]
                                      )
                                    : _vm.showLoadMore
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "homebase-btn-secondary",
                                          on: { click: _vm.onLoadMoreClicked }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                Load more\n                            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        ],
                        2
                      )
                    : _c("div", { staticClass: "mt-4" }, [
                        _vm._v("No events to display")
                      ])
                ])
              ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8624821a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8624821a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/eventsByInterests/EventFeed.vue
// module id = null
// module chunks = 